import { useAICoach } from '../../../hooks/useAICoach';
import { motion } from 'framer-motion';

export default function AICoach({ screen = 'home' }) {
  const { data: coach, isLoading } = useAICoach(screen);

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.1 }}
      style={{
        background: 'linear-gradient(135deg,rgba(232,255,71,0.07),rgba(10,10,11,0))',
        border: '1px solid rgba(232,255,71,0.18)',
        borderRadius: 16,
        padding: 14,
        marginBottom: 14,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
        <div style={{ width: 28, height: 28, borderRadius: 8, background: '#E8FF47', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14 }}>
          {isLoading ? '⏳' : (coach?.emoji || '🤖')}
        </div>
        <div style={{ fontSize: 10, fontWeight: 700, color: '#E8FF47', letterSpacing: 1 }}>AI COACH</div>
      </div>
      {isLoading ? (
        <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.4)' }}>Getting your personalised insight...</div>
      ) : (
        <>
          <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.85)', lineHeight: 1.55, marginBottom: 8 }}>{coach?.insight}</div>
          <div style={{ fontSize: 11, color: '#E8FF47', fontWeight: 500 }}>💡 {coach?.action}</div>
        </>
      )}
    </motion.div>
  );
}
